import React, { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { InputGroup } from "../helpers/components"
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { useAuth } from "../firebase/useAuth"

const stripePromise = loadStripe("pk_test_0kKLlfGgUzQHuAMSmkxNSwbj00swcH7K3o")

const GoPremiumForm = () => {
  const [error, setError] = useState(null)
  const stripe = useStripe()
  const elements = useElements()
  const [currentUser] = useAuth()

  // CLIENT INFOS STATE
  const [lastname, setLastname] = useState("")
  const [firstname, setFirstname] = useState("")
  const [email, setEmail] = useState("")
  const [birthday, setBirthday] = useState("")
  const [adress, setAdress] = useState("")
  const [city, setCity] = useState("")
  const [postalcode, setPostalcode] = useState("")

  useEffect(() => {
    if(currentUser) setEmail(currentUser?.email)
  }, [currentUser])

  const handleSubmit = async e => {
    e.preventDefault()
    if(!stripe || !elements) return
    
    const cardElement = elements.getElement(CardElement)

    const createPaymentResult = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    }) // return { error, paymentMethod }

    if(createPaymentResult?.error) return setError(paymentMethod.error)
  }

  const CARD_OPTIONS = {
    iconStyle: 'solid',
    style: {
      base: {
        iconColor: '#666ee8',
        color: '#31325f',
        fontWeight: 400,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '15px',
        '::placeholder': {
          color: '#aab7c4',
        },
        ':-webkit-autofill': {
          color: '#666ee8',
        },
      },
    },
  }

	return (
		<motion.div
			className="goPremiumForm"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
      <form className="paymentForm" onSubmit={handleSubmit}>
        <fieldset className="fieldset clientInfos">
          <legend className="legendTitle">Vos informations</legend>
          <InputGroup id="name" label="Nom" value={lastname} setValue={setLastname} placeholder="Durant" required />
          <InputGroup id="firstname" label="Prénom" value={firstname} setValue={setFirstname} placeholder="Sarah" required />
          <InputGroup id="email" label="Email" value={email} setValue={setEmail} type="email" placeholder="sarah.durant@gmail.com" required />
          <InputGroup id="birthday" label="Date de naissance" value={birthday} setValue={setBirthday} type="date" required />
          <InputGroup id="adress" label="Adresse" value={adress} setValue={setAdress} placeholder="Avenue Paul Doumer" required />
          <InputGroup id="city" label="Ville" value={city} setValue={setCity} placeholder="Paris" required />
          <InputGroup id="postalCode" label="Code postal" value={postalcode} setValue={setPostalcode} placeholder="75016" required />
        </fieldset>
        <fieldset className="fieldset">
          <legend className="legendTitle">Informations de paiement</legend>
          <div className="cardElementContainer">
            <CardElement options={CARD_OPTIONS} hidePostalCode={true} />
          </div>
        </fieldset>
        {error && <div className="error">{JSON.stringify(error, null, 2)}</div>}
        <button type="submit" className="submitBtn">Valider mon abonnement</button>
      </form>
		</motion.div>
	)
}


export default function ExportedGoPremiumForm() {
  return (
    <Elements stripe={stripePromise}>
      <GoPremiumForm />
    </Elements>
  )
}